import { useEffect, useState } from 'react';
import SummaryChart from './summary-charts';
import { Grid, Box, Table, TableCell, TableContainer, Paper, TableRow, TableBody, TableHead, Typography } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';


const SupplierSummary = ({ selectedRows: selectedRows, initialRows: initialRows, pending, complete }) => {
    const [firstRows, setFirstRows] = useState(initialRows);
    const [rows, setRows] = useState(selectedRows);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    useEffect(() => {
        setFirstRows(initialRows)
        setRows(selectedRows);
    }, [selectedRows, initialRows]);

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });

        const sortedRows = [...rows].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setRows(sortedRows);
    };

    return (
        <>
            {rows.length !== 0 ? <Grid className="grid-example"  container p={10}>
                <Grid item size={6}>
                    <Box p={4}>
                        <SummaryChart chartHeader={"Recent initiative"} pending={pending} complete={complete} rows={rows} />
                    </Box>
                </Grid>
                <Grid item size={6}>
                    <Box p={2}>
                        <TableContainer style={{ maxWidth: '995px', margin: 'auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="notify-head" onClick={() => handleSort('supplier')} align="center">
                                            <Typography variant="h3">
                                                Supplier # <UnfoldMoreIcon fontSize="small" />
                                            </Typography>
                                        </TableCell>
                                        <TableCell className="notify-head" onClick={() => handleSort('status')} align="center">
                                            <Typography variant="h3">
                                                Status <UnfoldMoreIcon fontSize="small" />
                                            </Typography>
                                        </TableCell>
                                        <TableCell className="notify-head" onClick={() => handleSort('doneDate')} align="center">
                                            <Typography variant="h3">
                                                Confirmation date <UnfoldMoreIcon fontSize="small" />
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell colSpan={3} style={{ padding: '1px' }}>
                                                <Box component={Paper} elevation={3}
                                                    style={{
                                                        margin: '6px 0',
                                                        padding: '12px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#ffffff'
                                                    }}>
                                                    <Box style={{ width: '30%', textAlign: 'center' }}>
                                                        <Typography variant="body2">{row.supplier}</Typography>
                                                    </Box>
                                                    <Box style={{ width: '30%', textAlign: 'center' }}>
                                                        <Typography variant="body2">{row.status}</Typography>
                                                    </Box>
                                                    <Box style={{ width: '30%', textAlign: 'center' }}>
                                                        <Typography variant="body2">{row.doneDate}</Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>
            </Grid>
                :
                <Grid className="grid-example" container p={10}>
                    {firstRows.map((row, index) => {

                        return (
                            <Grid item xs={4} key={index}>
                                <Box p={4}>
                                    <SummaryChart
                                        chartHeader={"Recent initiative"}
                                        pending={row.status?.trim().toLowerCase() === "pending" ? 1 : 0}
                                        complete={row.status?.trim().toLowerCase() === "complete" ? 1 : 0}
                                        rows={[row]}
                                    />
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            }
        </>
    );
};

export default SupplierSummary;